import { useEffect, useState } from 'react';
import { Loader, ThemeProvider } from '@aws-amplify/ui-react';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import { FaceInviteBackgroundIcon, FaceInviteDoneIcon, FalconLogo } from '../../icon';
import * as selector from "../../selectors/selectors";
import { useSelector } from 'react-redux';
import { SecureFileService } from '../../services/SecureFileService';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';
import setToast from '../../helpers/toaster.helper';
import { ToasterTexts } from '../shared/constants';
import { ToasterType } from '../shared/toaster/toaster.model';

const FaceRegister = () => {
    const [loading, setLoading] = useState(true)
    const [isValid, setIsValid] = useState(false)
    const [imageData, setImageData] = useState(null)
    const [isTimeout, setIsTimeout] = useState(false)
    const [isValidationMessage, setValidationMessage] = useState('')
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [createLivenessApiData, setCreateLivenessApiData] = useState(null)
    const [isRegistrationSuccessful, setIsRegistrationSuccessful] = useState(false)

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const userId = queryParams.get('id');
        const fetchCreateLiveness = async () => {
            try {
                SecureFileService.ValidateRegisterlink(userId).then((res) => {
                    if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                        if (res.data.message !== "Validation successful") {
                            setValidationMessage(res.data.message)
                        }
                        setCreateLivenessApiData(res.data)
                        setLoading(false)
                    }
                    else {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    }
                }).catch((err) => {
                    setValidationMessage(err.response?.data?.error)
                    setLoading(false)
                })
            } catch (error) {
                setLoading(false)
            }
        }
        fetchCreateLiveness()
    }, [])

    const handleAnalysisComplete = async () => {
        const { sessionId, phoneNumber, organization_id, falkon_user } = createLivenessApiData
        try {
            SecureFileService.faceRegister({ id: phoneNumber, sessionId, organization_id, falkon_user }).then((res) => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    if (res.data.message === 'Face successfully indexed') {
                        setIsRegistrationSuccessful(true)
                    }
                    if (res.data.image) {
                        const imageDataUrl = `data:image/jpeg;base64,${res.data.image}`
                        setImageData(imageDataUrl);
                    }
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
            }).catch((err) => {
            })
        } catch (error) {
        }
    }

    return (
        <ThemeProvider>
            {loading ? (
                <div className="d-flex flex-direction justify-center align-center">
                    <Loader />
                </div>)
                :
                (!IsMobileDevice ?
                    (
                        <div className="d-flex flex-direction justify-center align-center p-relative h-v-100">
                            {!isRegistrationSuccessful && !isValidationMessage &&
                                <div className="br-5 mt-4 bg-color-photosensitivity-warning p-absolute" style={{ top: '10px', right: '-12px', maxWidth: '418px', zIndex: '1000' }}>
                                    <div className="h6-regular m-1">⚠️ Photosensitivity warning</div>
                                    <p className="h7-regular mx-2">This check flashes different colors. Use caution if you are photosensitive.</p>
                                </div>
                            }
                            <header className="d-flex flex-direction justify-center align-center">
                                {!isValidationMessage && <div className="mb-1">
                                    <FalconLogo />
                                </div>}
                                {!isRegistrationSuccessful && !isValidationMessage && (
                                    <h2 className="h2-semibold color-settings-heading">Let’s Register your face</h2>
                                )}
                                {!isRegistrationSuccessful && !isValidationMessage && (<div className='h5-regular color-settings-heading '>Please center your face to begin the facial recognition process</div>)}
                            </header>
                            <div style={{ width: '100%', maxWidth: '400px', aspectRatio: '1/1' }}>
                                {(!isRegistrationSuccessful && !isValidationMessage) ? (
                                    isTimeout ? (
                                        <div className="h3-semibold mt-26 justify-center align-center d-flex">
                                            Timeout: Please try again later!
                                        </div>
                                    ) : isValid ? (
                                        <div className="h3-semibold mt-26 justify-center align-center d-flex">
                                            {isValidationMessage}
                                        </div>
                                    ) : (
                                        <FaceLivenessDetector
                                            sessionId={createLivenessApiData?.sessionId}
                                            region="us-east-1"
                                            onAnalysisComplete={handleAnalysisComplete}
                                            onError={(error) => {
                                                switch (error.state) {
                                                    case "SERVER_ERROR":
                                                        setIsValid(true)
                                                        break
                                                    case "CONNECTION_TIMEOUT":
                                                        setIsTimeout(true)
                                                        break
                                                    default:
                                                        break
                                                }
                                            }}
                                            components={{
                                                PhotosensitiveWarning: () => null,
                                            }}
                                            displayText={{ hintCenterFaceInstructionText: "", hintCenterFaceText: "" }}
                                        />
                                    )
                                ) : (
                                    <>
                                        {isValidationMessage ? (
                                            <div className="d-flex flex-direction justify-center align-center">
                                                <div className="mb-1">
                                                    <FalconLogo />
                                                </div>
                                                <div className="h3-semibold mt-20 justify-center align-center d-flex login-background p-3">
                                                    {isValidationMessage}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex justify-center align-center p-relative">
                                                <div className="d-flex justify-center align-center p-relative d-inline-block m-auto">
                                                    <FaceInviteBackgroundIcon
                                                        className="mt-5 d-flex justify-center align-center p-relative h-auto w-85 h-28"
                                                        style={{ zIndex: '1px' }}
                                                    />
                                                    <div
                                                        className="d-flex justify-center align-center p-absolute t-p-50 l-p-50"
                                                        style={{ zIndex: '2px', transform: 'translate(-50%, -60%)' }}
                                                    >
                                                        <img
                                                            src={imageData}
                                                            alt="Captured face liveness result"
                                                            className="mt-15 d-flex justify-center align-center br-8 w-p-100 h-p-100"
                                                            style={{
                                                                border: '4px solid white',
                                                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                                            }}
                                                        />
                                                        <FaceInviteDoneIcon
                                                            className="p-absolute w-11 h-11"
                                                            style={{ bottom: '-28px', right: '-38px' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {!isValidationMessage && (
                                            <div className="d-flex mt-10 justify-center align-center h1-semibold color-settings-heading">
                                                Registration Successful
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    ) :
                    (
                        <div className="d-flex flex-direction align-center h-v-100">
                            <header className="d-flex flex-direction justify-center align-center">
                                <div className="mt-4">
                                    <FalconLogo />
                                </div>
                                {!isRegistrationSuccessful && !isValidationMessage && (
                                    <div className="h3-semibold mt-1 color-settings-heading t-align-center">Let’s Register your face</div>
                                )}
                                {!isRegistrationSuccessful && !isValidationMessage &&
                                    (<div className='h4-regular mx-2 my-1 t-align-center color-settings-heading '>Please center your face</div>)}
                            </header>
                            <div style={{ width: '64%', maxWidth: '400px', aspectRatio: '1/1' }} className=''>
                                {(!isRegistrationSuccessful && !isValidationMessage) ? (
                                    isTimeout ? (
                                        <div className="h5-semibold mt-28 t-align-center">
                                            Timeout: Please try again later!
                                        </div>
                                    ) : isValid ? (
                                        <div className='flex-direction'>
                                            <div className="h3-semibold mt-28 t-align-center">
                                                {isValidationMessage}
                                            </div>
                                        </div>
                                    ) : (
                                        <FaceLivenessDetector
                                            sessionId={createLivenessApiData?.sessionId}
                                            region="us-east-1"
                                            onAnalysisComplete={handleAnalysisComplete}
                                            onError={(error) => {
                                                switch (error.state) {
                                                    case "SERVER_ERROR":
                                                        setIsValid(true)
                                                        break
                                                    case "CONNECTION_TIMEOUT":
                                                        setIsTimeout(true)
                                                        break
                                                    default:
                                                        break
                                                }
                                            }}
                                            components={{
                                                PhotosensitiveWarning: () => null,
                                            }}
                                            displayText={{ hintCenterFaceInstructionText: "", hintCenterFaceText: "" }}
                                        />
                                    )
                                ) : (
                                    <>
                                        <div className='flex-direction'>
                                            {isValidationMessage ? (
                                                <div className="d-flex">
                                                    <div className="h3-semibold mt-6 t-align-center">
                                                        {isValidationMessage}
                                                    </div>
                                                </div>
                                            ) : (
                                                <img
                                                    src={imageData}
                                                    alt="Captured face liveness result"
                                                    className="my-2 d-flex justify-center align-center br-50 w-p-100 h-p-100"
                                                    style={{ border: "4px solid white", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
                                                />
                                            )}
                                            {!isValidationMessage && (
                                                <div className="d-flex mt-2 justify-center align-center h3-semibold color-settings-heading">
                                                    Registration Successful
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )
                )}
        </ThemeProvider>
    )
}
export default FaceRegister